module.exports = __webpack_public_path__ + "static/media/2DGACM16.1c5bd00c.jpg";